
/*
 TRINITY ARMAMENT
 THE GOBLIN TAX DEPARTMENT
 EASTER EGG #2
*/

document.addEventListener("DOMContentLoaded", () => {

  const DISCOUNT_CODE = "GOBLINTAX";

  const insults = [
    "Your financial situation has been classified as tragic.",
    "We've seen abandoned shopping carts with better credit.",
    "The goblin checked your balance and started crying.",
    "Your wallet has been reported missing since 2019.",
    "Even the IRS feels bad for you.",
    "Your purchasing power is approximately one chicken nugget.",
    "The goblin recommends getting a second job.",
    "Your bank account has requested witness protection.",
    "You have been identified as financially aerodynamic.",
    "The goblin considered taxing you more, but there's nothing left."
  ];

  // BUILD POPUP

  const overlay = document.createElement("div");
  overlay.id = "trinity-goblin-overlay";

  overlay.innerHTML = `
    <div class="trinity-goblin-box"
         role="dialog"
         aria-modal="true"
         aria-labelledby="trinity-goblin-title">

      <button
        class="trinity-goblin-close"
        type="button"
        aria-label="Close popup"
      >×</button>

      <div class="trinity-goblin-stamp">
        DEPARTMENT OF GOBLIN AFFAIRS
      </div>

      <h2 id="trinity-goblin-title">
        OFFICIAL TAX AUDIT
      </h2>

      <div class="trinity-goblin-skull">
        💀
      </div>

      <p class="trinity-goblin-status">
        AUDIT COMPLETE
      </p>

      <p id="trinity-goblin-insult"></p>

      <div class="trinity-goblin-refund">
        <span>REFUND APPROVED</span>
        <strong>$0.01</strong>
      </div>

      <p class="trinity-goblin-disclaimer">
        The Department of Goblin Affairs
        regrets this act of generosity.
      </p>

      <button
        type="button"
        id="trinity-goblin-claim"
      >
        CLAIM MY FORTUNE
      </button>

      <div
        id="trinity-goblin-response"
        aria-live="polite"
      ></div>

    </div>
  `;

  document.body.appendChild(overlay);

  // ELEMENTS

  const box = overlay.querySelector(".trinity-goblin-box");
  const insultText = overlay.querySelector("#trinity-goblin-insult");
  const response = overlay.querySelector("#trinity-goblin-response");
  const claim = overlay.querySelector("#trinity-goblin-claim");
  const closeButton = overlay.querySelector(".trinity-goblin-close");

  let previousFocus = null;
  let claimTimer = null;

  // OPEN POPUP

  function openGoblin() {
    previousFocus = document.activeElement;

    clearTimeout(claimTimer);

    const randomInsult =
      insults[Math.floor(Math.random() * insults.length)];

    insultText.textContent = randomInsult;

    response.innerHTML = "";

    claim.disabled = false;
    claim.textContent = "CLAIM MY FORTUNE";

    overlay.classList.add("active");

    document.body.style.overflow = "hidden";

    closeButton.focus();
  }

  // CLOSE POPUP

  function closeGoblin() {
    clearTimeout(claimTimer);

    overlay.classList.remove("active");

    document.body.style.overflow = "";

    if (previousFocus && previousFocus.focus) {
      previousFocus.focus();
    }
  }

  // OPEN FROM CART TRIGGER

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-goblin-tax]");

    if (trigger) {
      event.preventDefault();
      openGoblin();
    }
  });

  // CLOSE BUTTON

  closeButton.addEventListener("click", closeGoblin);

  // CLOSE BY CLICKING BACKGROUND

  overlay.addEventListener("click", (event) => {
    if (event.target === overlay) {
      closeGoblin();
    }
  });

  // KEYBOARD SUPPORT

  document.addEventListener("keydown", (event) => {
    if (!overlay.classList.contains("active")) return;

    if (event.key === "Escape") {
      closeGoblin();
      return;
    }

    if (event.key === "Tab") {
      const focusable = [
        ...overlay.querySelectorAll(
          "button:not([disabled])"
        )
      ].filter(el => el.getClientRects().length);

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (!first || !last) return;

      if (event.shiftKey &&
          document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey &&
                 document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  // CLAIM REFUND

  claim.addEventListener("click", () => {

    claim.disabled = true;
    claim.textContent = "PROCESSING REFUND...";

    response.textContent =
      "CONTACTING THE DEPARTMENT OF GOBLIN AFFAIRS...";

    claimTimer = setTimeout(() => {

      claim.textContent = "REFUND AUTHORIZED";

      response.innerHTML = `
        <p style="
          color:#00e5d0;
          line-height:1.7;
          margin:16px 0;
        ">
          Congratulations, parasite.<br>
          Your financial future has improved by $0.01.
        </p>

        <div
          id="trinity-goblin-code"
          style="
            border:1px dashed #00e5d0;
            padding:14px;
            margin:15px 0;
            color:#fff;
            font-size:20px;
            letter-spacing:2px;
            font-family:monospace;
            user-select:all;
          "
        >
          ${DISCOUNT_CODE}
        </div>

        <button
          type="button"
          id="trinity-copy-goblin"
          style="
            background:transparent;
            border:1px solid #00e5d0;
            color:#00e5d0;
            padding:12px 18px;
            cursor:pointer;
            font-family:monospace;
            font-size:12px;
            letter-spacing:1px;
            max-width:100%;
          "
        >
          COPY MY PATHETIC REFUND
        </button>

        <p style="
          color:#888;
          font-size:11px;
          line-height:1.6;
          margin-top:15px;
        ">
          Apply this code at checkout.<br>
          Don't spend it all in one place.
        </p>
      `;

      // COPY DISCOUNT CODE

      const copyButton = response.querySelector(
        "#trinity-copy-goblin"
      );

      copyButton.addEventListener("click", async () => {

        try {
          await navigator.clipboard.writeText(DISCOUNT_CODE);

          copyButton.textContent = "COPIED!";

        } catch (error) {

          // FALLBACK FOR OLDER BROWSERS

          const codeElement = response.querySelector(
            "#trinity-goblin-code"
          );

          const selection = window.getSelection();
          const range = document.createRange();

          range.selectNodeContents(codeElement);

          selection.removeAllRanges();
          selection.addRange(range);

          copyButton.textContent =
            "CODE SELECTED — COPY MANUALLY";
        }
      });

      copyButton.focus();

    }, 1200);
  });

});
